import * as React from "react";
import { Grid } from "@mui/material";

import { DynamicField } from "@/components/dynamicField/dynamic-field";
import { DynamicFieldType } from "@/components/dynamicField/types";

export function Service({
	control,
	service,
	onPluginChange,
	plugins,
	settings,
}: {
	control: any;
	service: any;
	onPluginChange: (service: string, plugin: string) => void;
	plugins: any;
	settings: any;
}) {
	return (
		<Grid container spacing={2}>
			<Grid
				size={{
					md: 12,
					xs: 12,
				}}
			>
				<DynamicField
					control={control}
					type={DynamicFieldType.SELECT}
					name={`${service}.pluginId`}
					label="Plugin"
					onChange={(value) => onPluginChange(service, value)}
					dynamicField={{
						name: `${service}.pluginId`,
						required: true,
						type: DynamicFieldType.SELECT,
						label: "Plugin",
						placeholder: "Select a plugin",
						options: plugins?.map((plugin: any) => ({ value: plugin.id, label: plugin.title })),
					}}
				/>
			</Grid>

			{!!settings?.length &&
				settings.map((setting: any) => (
          <DynamicField
            key={setting.name}
            gridSize={{ md: 12, xs: 12 }}
            control={control}
            type={setting.type}
            name={`${service}.settings.${setting.name}`}
            label={setting.label}
            dynamicField={setting}
            dependsOn={setting.dependsOn}
            formName={`${service}.settings`}
          />
				))}
		</Grid>
	);
}
